import { GdsSeatService, Seat } from '../../../../types';
import { PassengerState } from '../../../../../Checkout/store/passengers/reducers';
import { SeatMapRestrictions } from '@websky/graphql';

type SeatService = {
	id?: string;
};

export type SeatType = {
	seatService?: SeatService;
	seatServices?: SeatService[];
};

export interface GetSeatAvailabilityParam {
	seat: Seat;
	passenger: PassengerState;
	activeFilters: SeatMapRestrictions[];
	segmentId: string;
}

export const getSeatAvailability = (params: GetSeatAvailabilityParam) => {
	const { seat, passenger, segmentId, activeFilters } = params;

	const firstService = seat.services?.[0];

	const isAllowedForSegment =
		firstService && firstService.allowedSegments.some(allowedSegment => allowedSegment[0] === segmentId);

	const isAllowedForPassenger =
		firstService && firstService.allowedPassengers.some(allowedPassenger => allowedPassenger[0] === passenger.id);

	const isAllowedByFilters = activeFilters.every(filter => !seat.restrictions?.includes(filter));

	let isAvailable = seat.isAvailable && seat.isExistent;

	if (seat.seatService) {
		isAvailable = isAvailable && isAllowedForSegment && isAllowedForPassenger;
	}

	return isAvailable && isAllowedByFilters;
};

export const getAllowedPassengerSeatServices = (
	passengerServices: {
		[p: string]: GdsSeatService;
	},
	seat: SeatType
) => {
	if (!passengerServices || Object.keys(passengerServices).length === 0) {
		return null;
	}

	const services: GdsSeatService[] = [];

	// если у места несколько услуг, сохраняем доступные
	if (!!seat.seatServices?.length) {
		seat.seatServices.forEach(service => {
			if (passengerServices[service.id] && passengerServices[service.id].canBeAdded) {
				services.push(passengerServices[service.id]);
			}
		});

		return services;
	} else if (!!seat.seatService?.id) {
		return [passengerServices[seat.seatService.id]];
	}

	return null;
};
